import firebase from "firebase";
import "firebase/firestore";

const development = {
  apiKey: "AIzaSyBdA9b16UE5ftbyvmsLvTO22OFmQ7QoLZA",
  authDomain: "invoicing-bonos-be-dev.firebaseapp.com",
  databaseURL: "https://invoicing-bonos-be-dev.firebaseio.com",
  projectId: "invoicing-bonos-be-dev",
  storageBucket: "invoicing-bonos-be-dev.appspot.com",
  messagingSenderId: "98585799510",
  appId: "1:98585799510:web:36aba99c0358644bb244f7"
};

const production = {
  apiKey: "AIzaSyC294aPp9FN9RjRWkmruoTmjc_FDyHMxwg",
  authDomain: "invoicing-bonos-be.firebaseapp.com",
  databaseURL: "https://invoicing-bonos-be.firebaseio.com",
  projectId: "invoicing-bonos-be",
  storageBucket: "invoicing-bonos-be.appspot.com",
  messagingSenderId: "655730516559",
  appId: "1:655730516559:web:a95abdc6a82b4a9d"
};

if (process.env.NODE_ENV === "development") {
  firebase.initializeApp(development);
} else if (process.env.NODE_ENV === "production") {
  firebase.initializeApp(production);
}

const db = firebase.firestore();
const storage = firebase.storage();

export { db, storage };
